import httpClient from './httpClient'

export default class {
  static async fetchTheme(domainName) {
    try {
      const res = await httpClient.get(`/theme/me?domain_name=${domainName}`)
      return res.data
    } catch (e) {
      console.log(e, 'error of theme.fetchTheme')
      throw e
    }
  }
  static async fetchAllTheme() {
    try {
      const res = await httpClient.get(`/theme`)
      return res.data
    } catch (e) {
      console.log(e, 'error of theme.fetchAllTheme')
      throw e
    }
  }
  static async saveTheme(body, systemOwnerId) {
    try {
      const res = await httpClient.put(
        `/system_owner/${systemOwnerId}/theme`,
        body,
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of theme.fetchTheme')
      throw e
    }
  }
}
